<template>
  <div class="bidinfo_module">
    <div class="bidinfo_banner">
      <img src="../../../../static/img/bidding/biddingbg.png" alt="" width="100%">
    </div>
    <div class="bidinfo_cup">
      <div class="bidinfo_content">
        <div class="bid_bread">
          <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item :to="{ name:'iaic2019en/bidding' }">Bidding Home</el-breadcrumb-item>
            <el-breadcrumb-item>{{bidItem}}</el-breadcrumb-item>
          </el-breadcrumb>
        </div>
        <div class="bid_title_cup">
          <h2 class="bidinfo_title">{{bidsName}}</h2>
        </div>
        <div class="bidinfo_line">
          <el-divider></el-divider>
        </div>
        <div class="bidInfo_other">
          <span>Time：{{promTime}}</span>&nbsp;&nbsp;&nbsp;&nbsp;<span>Source：IAIC</span>
        </div>
        <div class="bisinfo_text">
          <div v-html="bidInfo"></div>
        </div>
        <div></div>
      </div>
    </div>
  </div>
</template>
<script>
import { bidInfo } from '@/api/enFrontApi/bidding';
export default {
  data() {
    return {
      bidInfo: '',
      bidsName: '',
      addUser: '',
      promTime: '2019-2-11',
      bidItem: 'Bidding News'
    };
  },
  created() {
    this.bidItem = this.$route.params.itemNmae;
    this.initBiddingInfo(this.$route.params.bidId);
  },
  methods: {
    initBiddingInfo(biddingId) {
      bidInfo(biddingId).then(res => {
        this.bidInfo = res.data.bidsBody;
        this.bidsName = res.data.bidsName;
        // this.promTime = res.data.promTime.substring(0, 10);
        this.promTime = res.data.promTime;
        this.addUser = res.data.addUser;
      });
    }
  }
};
</script>
<style lang="stylus" scoped>
.bidinfo_module {
  width: 100%;
  background-color: #F8F8F8;
}

.bidinfo_cup {
  width: 100%;
  min-height: 500px;
  padding: 20px 0;

  .bidinfo_content {
    width: 60%;
    margin: 0 auto;
    min-height: 500px;
    background-color: #fff;

    .bid_bread {
      height: 30px;
      padding: 20px 0 0 35px;
    }

    .bid_title_cup {
      width: 100%;
      text-align: center;
      color: #006980;
    }

    .bidinfo_line {
      widrh: 80%;
      padding: 0 20px;
    }

    .bidInfo_other {
      text-align: center;
      width: 100%;
    }

    .bisinfo_text {
      padding: 0 20px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/enViews/bidding/biddingInfo.vue